export default {
    "Tipo 4": "https://umbra3d.studio/recorridos/mas-developers/casa-ambar/",
    "Apto Tipo Tipo 4": "https://umbra3d.studio/recorridos/mas-developers/casa-ambar/",
    "Spa": "https://umbra3d.studio/recorridos/mas-developers/casa-ambar-zonas-sociales/",
    "General View": "https://umbra3d.studio/recorridos/mas-developers/casa-ambar-zonas-sociales/",
}